export class LocalStorageTourStorage {
    prefix;
    constructor(prefix = 'dw.tour.') {
        this.prefix = prefix;
    }
    k(key) {
        return `${this.prefix}${key}`;
    }
    get(key) {
        if (typeof window === 'undefined')
            return null;
        try {
            return window.localStorage.getItem(this.k(key));
        }
        catch {
            // ignore Storage access errors
            return null;
        }
    }
    set(key, value) {
        if (typeof window === 'undefined')
            return;
        try {
            window.localStorage.setItem(this.k(key), value);
        }
        catch {
            // ignore quota/security errors
        }
    }
    remove(key) {
        if (typeof window === 'undefined')
            return;
        try {
            window.localStorage.removeItem(this.k(key));
        }
        catch {
            // ignore storage errors
        }
    }
}
export const memoryStorage = () => {
    const map = new Map();
    return {
        get: (k) => map.get(k) ?? null,
        set: (k, v) => map.set(k, v),
        remove: (k) => void map.delete(k),
    };
};
//# sourceMappingURL=storage.js.map